// src/components/LegalPage.js
import React, { useContext } from 'react';
import { LanguageContext } from '../translations/LanguageContext';
import ReactMarkdown from 'react-markdown';
import './LegalPage.css'; // Import the corresponding CSS
import Footer from '../components/Footer'; // Importing the Footer component

function LegalPage() {
  const { language, translations } = useContext(LanguageContext);
  const legal = translations[language].legalPage;

  return (
  <div>
    <div className="legal-page">
      <h1>{legal.title}</h1>
      <div className="legal-content">
        <ReactMarkdown>{legal.content}</ReactMarkdown>
      </div>
    </div>
    <Footer/>
  </div>
  );
}

export default LegalPage;
